// AUTO-GENERATED GraphQL Builder for PaymentSplitResult
import * as Builders from '../';
export class PaymentSplitResultBuilder {
  private s:string[]=[]; private r:string[]=[]; private v=new Set<string>(); depth=0;
  private add(f:string){ if(!this.s.includes(f)) this.s.push(f); return this; }
  getSelections(){ return [...this.s]; }
  toSelectionSet(){ const a=[...this.s,...this.r]; if(!a.length)return`{ id }`; return`{\n  ${a.join("\n  ")}\n}`;}
  paymentId(){ return this.add('paymentId'); }
  simulated(){ return this.add('simulated'); }

  lines(b?:(q:Builders.PaymentSplitLineBuilder)=>void){
    if(this.depth>=5||this.v.has('lines'))return this;
    this.v.add('lines');
    const n=new Builders.PaymentSplitLineBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`lines { ${inner} }`);
    return this;
  }
}
